const Academics = () => {
  return (
    <div className="max-w-5xl mx-auto px-6 py-12">
      <h1 className="text-3xl font-bold mb-6">Academics</h1>
      <p className="text-lg text-gray-700 leading-relaxed">
        Explore our academic programs, curriculum, and academic resources.
      </p>
    </div>
  );
};

export default Academics;
